// Generated by ReScript, PLEASE EDIT WITH CARE


var title = {
  id: "697308bc-b6eb-4e35-b95b-7a473e988341",
  defaultMessage: "Tracking and Validation PERF / POOL / PSER"
};

var numberSelected = {
  id: "1b0a73c0-5a2e-43c6-941f-f98024874fca",
  defaultMessage: "{number} selected"
};

var totalBonusAmount = {
  id: "7e89d66c-4b51-4193-9113-690a55c8cf29",
  defaultMessage: "Total amount of bonus: {amountEuro} €"
};

var refuseBonus = {
  id: "70c9e7a9-ad2f-4b1b-9e93-729f13bf7fb3",
  defaultMessage: "Refuse"
};

var modifyStatus = {
  id: "d0858fdd-4515-4738-be2b-f4d85ca1565d",
  defaultMessage: "Change action status"
};

var modifyAmount = {
  id: "74519c25-b1d0-4470-85c3-2d7b0bce9677",
  defaultMessage: "Modify action amount"
};

var modalModifyStatusTitle = {
  id: "846bdc74-fc17-4ca7-9666-003351d37317",
  defaultMessage: "Edit a status"
};

var modalRefuseTitle = {
  id: "1a25a1cd-f983-442a-8f9d-426b7ad75ebb",
  defaultMessage: "Refuse a bonus"
};

var modalModifyAmountTitle = {
  id: "6377c5d6-834b-4a4b-8b0b-80b500696b39",
  defaultMessage: "Modify an amount"
};

var modalValidateTitle = {
  id: "3f8b37b8-2cd0-4098-8d4f-02a7cbbcebb7",
  defaultMessage: "Validate a bonus"
};

var modalDerogateTitle = {
  id: "2ab578d4-8478-44da-8ab8-598a0527ed2f",
  defaultMessage: "Derogate a bonus"
};

var amountFromDealer = {
  id: "26fb798e-a1b8-42dc-a6ba-5af0d515aaf5",
  defaultMessage: "Amount claimed by dealer"
};

var authorizedAmount = {
  id: "8586206e-91e3-4615-8ba2-f3611e5c2b92",
  defaultMessage: "Max authorized amount"
};

var newAmount = {
  id: "70697e00-d31a-4a78-ad60-220a6e0ac6d7",
  defaultMessage: "New amount"
};

var currentStatus = {
  id: "a0d8ef92-faf4-48cf-86f0-de90fea57681",
  defaultMessage: "Current status"
};

var newStatus = {
  id: "1b772116-429e-4cc1-9106-451ea1bd84a9",
  defaultMessage: "New status"
};

var refusalMotive = {
  id: "208cfb30-5825-4d69-81c8-d8604cb45fad",
  defaultMessage: "Motive of refusal"
};

var refusalMotiveMax100 = {
  id: "b0833f5a-382d-45de-b4d8-8421495520ca",
  defaultMessage: "Refusal reason (100 chars max)"
};

var otherRefusalMotive = {
  id: "ca91ff7b-3fa0-4536-bef1-99a6b3bf588f",
  defaultMessage: "Other refusal reason (100 chars max)"
};

var refusalConfirmation = {
  id: "3fff444d-387c-48c5-b430-5c871d25fe89",
  defaultMessage: "Do you want to refuse this bonus?"
};

var validationConfirmation = {
  id: "f0015194-4e76-47b4-ba8e-a7e290d9c5f7",
  defaultMessage: "Are you sure you want to validate the bonus?"
};

var derogationConfirmation = {
  id: "aeed29b3-baa5-4966-9ed1-b9656508b8f7",
  defaultMessage: "Are you sure you want to derogate the bonus?"
};

var validateSuccess = {
  id: "cfefd24d-9fb7-41a7-8dfc-256b3fdee9da",
  defaultMessage: "Validation of the budget carried out"
};

var refusedSuccess = {
  id: "efafad86-9a93-4426-8254-dbd1b9e7dfdc",
  defaultMessage: "The aid was refused"
};

var amountChangeSuccess = {
  id: "86225fdc-49a1-449d-b343-0c3da3ea211c",
  defaultMessage: "The amount of bonus has been modified"
};

var derogationSuccess = {
  id: "d582302f-0603-4889-9c6c-73d67010857e",
  defaultMessage: "Bonus has been derogated"
};

var backToValidateSuccess = {
  id: "c5d09a2e-970a-410b-8930-aaa50f74f003",
  defaultMessage: "The bonus has been returned to TO VALIDATE status"
};

var searchExceededAmount = {
  id: "3459b74f-21f7-414f-bd81-4ad47c2a48f5",
  defaultMessage: "Search for exceeding amounts"
};

var toValidateStatus = {
  id: "1b1fc139-a323-42fa-aa36-607e4e2da03f",
  defaultMessage: "To Validate"
};

var mrWarningNoMoreResources = {
  id: "b4c2dee2-7fdd-429b-ac48-0793c848700b",
  defaultMessage: "No budget available for the period covered by the order"
};

var adminsWarningNoMoreResources = {
  id: "db946c0e-19e2-4e7d-bbbd-9f4edcda0c51",
  defaultMessage: "Validation impossible. The MR responsible for approving this bonus request no longer has enough budget for the period covered by this order"
};

export {
  title ,
  numberSelected ,
  totalBonusAmount ,
  refuseBonus ,
  modifyStatus ,
  modifyAmount ,
  modalModifyStatusTitle ,
  modalRefuseTitle ,
  modalModifyAmountTitle ,
  modalValidateTitle ,
  modalDerogateTitle ,
  amountFromDealer ,
  authorizedAmount ,
  newAmount ,
  currentStatus ,
  newStatus ,
  refusalMotive ,
  refusalMotiveMax100 ,
  otherRefusalMotive ,
  refusalConfirmation ,
  validationConfirmation ,
  derogationConfirmation ,
  validateSuccess ,
  refusedSuccess ,
  amountChangeSuccess ,
  derogationSuccess ,
  backToValidateSuccess ,
  searchExceededAmount ,
  toValidateStatus ,
  mrWarningNoMoreResources ,
  adminsWarningNoMoreResources ,
}
/* No side effect */
